import { RegionType } from '@wix/shoutout-email-model-v3';
import * as cssUtils from '../../utils/css-utils';
import { getContentWidth } from '../../utils/get-message-width';
export var getLinkSection = function (_a) {
    var region = _a.region, css = _a.css, composerData = _a.composerData, isRtl = _a.isRtl;
    if (region.type !== RegionType.Link) {
        throw Error('Link must be passed');
    }
    var _b = region.data.extracted, description = _b.description, images = _b.images, originalUrl = _b.originalUrl, title = _b.title, url = _b.url;
    var rules = [css['so-global-region-link'], css['so-global-region']];
    var mobileCssClass = cssUtils.getRegionMobileCssClass(rules);
    var innerPadding = cssUtils.padding(rules);
    var contentWidth = getContentWidth(composerData, css, rules) -
        (innerPadding.left || 0) -
        (innerPadding.right || 0);
    var columnsWidths = cssUtils
        .calculateColumnsProportions(contentWidth, [30, 70], innerPadding, isRtl)
        .map(function (val) { return val + "%"; });
    var imageUrl = images && images[0] && images[0].url;
    return {
        widthsForMediaQueries: columnsWidths,
        title: title,
        description: description,
        imageUrl: imageUrl,
        link: url || originalUrl,
        outerPadding: cssUtils.margin(rules),
        innerPadding: innerPadding,
        cssClass: mobileCssClass,
        imageCssClass: cssUtils.getTopPaddingRestrictionCssClass(rules),
        textCssClass: imageUrl
            ? cssUtils.getBottomPaddingRestrictionCssClass(rules)
            : cssUtils.getTopBottomPaddingRestrictionCssClass(rules),
        columnsWidths: columnsWidths,
    };
};
//# sourceMappingURL=get-link-section.js.map